import React, {useEffect, useState} from 'react'
import {Controller, useForm} from 'react-hook-form'

import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent, DialogContentText,
  DialogTitle, IconButton, MenuItem, TextField, Typography
} from '@material-ui/core'
import HookForm from '../../components/common/HookForm'
import LoadingBackdrop from '../../components/common/LoadingBackdrop'
import SelectInput from '../../components/common/inputs/SelectInput'
import TextInput from '../../components/common/inputs/TextInput'
import styles from './EventDiscountCodesTable.module.css'
import axios from "axios";
import {
  Grid, SelectChangeEvent,
} from "@mui/material";
import {formatMoney} from "../../util/formatHelpers";
import DateTimeInput from "../../components/common/inputs/DateTimeInput";
import {useQueryClient} from "react-query";
import dayjs from "dayjs";


interface FormData {
  id: number
  discountactive: string
  discountamount: string
  discountcandelete: boolean
  discountcode: string
  discountdescription: string
  discountdateend: string
  discountid: number
  discountitemids: number[] | string
  discountitems: string
  discountmethod: string
  discountmethodid: number
  discountminimumpurchaseneeded: string
  discountminimumquantityneeded: number
  discountdatestart: string
  discounttype: string
  discounttypeid: number
}

export const EventDiscountCodesForm = ({ isOpen, setIsOpen, reloadForm, eventid, discountid }) => {
  const formMethods = useForm<FormData>()

  const queryClient = useQueryClient()
  const title = discountid > 0 ? "Edit Promo Code" : "Add Promo Code"
  const { setValue, watch, getValues, setError, clearErrors, setFocus, reset } = formMethods

  const [dialogMsg, setDialogMsg] = React.useState("")
  const [loading, setLoading] = React.useState(false)
  const [displayItemDiscount, setDisplayItemDiscount] = React.useState(true)
  const [displayPaymentMethodAmount, setDisplayPaymentMethodAmount] = React.useState(true)
  const discounttypeidWatch = watch('discounttypeid')
  const discountmethodidWatch = watch('discountmethodid')
  const discountamountWatch = watch('discountamount')

  const [dropdownData, setDropdownData] = React.useState({
    discounttypelist: [],
    itemlist: [],
    discountmethodlist: [],
  })
  const [discountData, setDiscountData] = React.useState({
    discountactive: 'active',
    discountamount: '',
    discountcandelete: true,
    discountcode: '',
    discountdescription: '',
    discountdateend: null,
    discountid: 0,
    discountitemids: "",
    discountitems: "",
    discountmethod: "",
    discountmethodid: 0,
    discountminimumpurchaseneeded: "",
    discountminimumquantityneeded: 1,
    discountdatestart: "",
    discounttype: '',
    discounttypeid: 0
  })

  useEffect(() => {
    console.log(discountid)
  }, [discountid])


  // useEffect(() => {
  //   var newData = {...discountData}
  //   console.log('amount watch')
  //   const discountObject = dropdownData?.discountmethodlist?.find(item => item.id === discountmethodidWatch)
  //   console.log(discountObject)
  //   if (discountObject?.code === 'M') {
  //     newData['discountamount'] = formatMoney(Number(discountamountWatch.replace('$', '')))
  //   }
  //   else {
  //     newData['discountamount'] = discountamountWatch + '%'
  //   }
  //   reset(newData)
  // }, [discountamountWatch])


  useEffect(() => {
    const discountObject = dropdownData?.discounttypelist?.find(item => item.id === discounttypeidWatch)
    if (discountObject?.code === 'I') {
      setDisplayItemDiscount(true)
    }
    else {
      setDisplayItemDiscount(false)
    }
  }, [discounttypeidWatch])

  useEffect(() => {
    const discountObject = dropdownData?.discountmethodlist?.find(item => item.id === discountmethodidWatch)
    if (discountObject?.code === 'M') {
      setDisplayPaymentMethodAmount(true)
    }
    else {
      setDisplayPaymentMethodAmount(false)
    }
  }, [discountmethodidWatch])

  useEffect(() => {
    const getData = async () => {
      await getDropdownData()
      if (discountid > 0) {
        getDiscountData()
      }
      else {
        // const dropDownTypeDefault = dropdownData?.discounttypelist[0]
        // const discountMethodList = dropdownData?.discountmethodlist[0]


        reset ({
          discountactive: 'active',
          discountamount: '',
          discountcandelete: true,
          discountcode: '',
          discountdescription: '',
          discountdateend: null,
          discountid: 0,
          discountitemids: [],
          discountitems: "",
          discountmethod: "",
          // discountmethodid: discountMethodList?.id,
          discountmethodid: 0,
          discountminimumpurchaseneeded: "",
          discountminimumquantityneeded: 1,
          discountdatestart: null,
          discounttype: '',
          // discounttypeid: dropDownTypeDefault?.id
          discounttypeid: 0
        })
      }
    }
    getData()
  }, [discountid, isOpen])

  const getDropdownData = async () => {
    setLoading(true)
    const { data } = await axios.post('/evtdiscountcodesdropdowns', {eventid: eventid})
    const parsedData = JSON.parse(data.jsonString)
    console.log(parsedData)
    setDropdownData(parsedData)
    setLoading(false)
  }

  const getDiscountData = async () => {
    setLoading(true)
    const { data } = await axios.post('/evtdiscountcodes', {eventid: eventid, discountid: discountid})
    const parsedData = JSON.parse(data.jsonString)
    var newData = {...parsedData}

    console.log(newData)

    if (!newData['discountdatstart']) {
      newData['discountdatestart'] = null
    }
    if (!newData['discountdateend']) {
      newData['discountdateend'] = null
    }

    newData['discountactive'] = parsedData['discountactive'] ? 'active' : 'inactive'

    newData['discountitemids'] = newData['discountitemids']
      ? String(newData['discountitemids']).split(',').map(Number).filter(n => !isNaN(n))
      : []

    setDiscountData(newData)

    reset(newData)

    const discountObject = dropdownData?.discounttypelist?.find(item => item.id === newData.discounttypeid)
    if (discountObject?.code === 'I') {
      setDisplayItemDiscount(true)
    }
    else {
      setDisplayItemDiscount(false)
    }

    setLoading(false)
  }

  const onSubmit = async (formdata: FormData) => {
    console.log(formdata)
    var amount = formdata['discountamount']

    var body = {
      eventid: eventid,
      delete: false,
      ...formdata,
      discountamount: amount,
      discountminimumpurchaseneeded: Number(formdata['discountminimumpurchaseneeded']),
      discountminimumquantityneeded: Number(formdata['discountminimumquantityneeded']),
      discountitemids: Array.isArray(formdata['discountitemids'])
        ? formdata['discountitemids'].join(',')
        : formdata['discountitemids']?.toString() ?? '',
      discounttype: formdata['discounttype'],
      active: formdata['discountactive'] === "active" ? true : false
    }

    if (body['discountdatestart'] == null) {
      delete body['discountdatestart'];
    }

    if (body['discountdateend'] == null) {
      delete body['discountdateend'];
    }


    const { data } = await axios.put('/evtdiscountcodes', body)
    const parsedData = JSON.parse(data.jsonString)

    if (parsedData?.status === 'failure') {
      setDialogMsg(parsedData.message)
    }
    else {
      queryClient.invalidateQueries(['evtdiscountcodes'])
      setIsOpen(false)
    }
  }

  const closeDialog = () => {
    setDialogMsg("")
  }

  const getItemListOptions = () => {
    if (dropdownData?.itemlist) {
      return dropdownData.itemlist.map((item) => ({value: item.itemid, label: item.itemname}))
    }
    return []
  }

  const getDiscountMethodOptions = () => {
    const dtRows = dropdownData?.discountmethodlist?.map((item) => {
      return {value: item.id, label: item.name}
    })
    return dtRows
  }

  const getDiscountTypeListOptions = () => {
    const dtRows = dropdownData?.discounttypelist?.map((item) => {
      return {value: item.id, label: item.name}
    })
    return dtRows
  }

  return (
    <>
      <Dialog open={isOpen} maxWidth="xl" fullWidth={true} className={styles.dialog}>
        <DialogTitle>{title}</DialogTitle>
        <LoadingBackdrop open={loading} />
        <>
          <Dialog
              open={dialogMsg.length > 0}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {dialogMsg}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={closeDialog}>Ok</Button>
            </DialogActions>
          </Dialog>
        </>
        <DialogContent>
          <HookForm
              methods={formMethods}
              onSubmit={onSubmit}
              className={styles.itemsForm}
              formProps={{ id: 'discount-form' }}
          >

            <Grid container spacing={1}>
              <Grid item xs={6} className={styles.selectcontrol}>
                <TextInput
                    name="discountcode"
                    label="Promo Code"
                    textFieldProps={{ fullWidth: true, required: true }}
                />
              </Grid>
              <Grid item xs={6} className={styles.selectcontrol}>
                <TextInput
                    name="discountdescription"
                    label="Description"
                    textFieldProps={{ fullWidth: true }}
                />
              </Grid>
              <Grid item xs={6} className={styles.selectcontrol} style={{marginTop: '10px'}}>
                <SelectInput
                    name="discounttypeid"
                    label="Discount Type"
                    required={true}
                    includeNone={false}
                    textFieldProps={{ fullWidth: true }}
                    options={getDiscountTypeListOptions()}
                    rules={{
                      validate: (val) => (val?.length === 0 || val === 'none' || val === 0) ?  "" : clearErrors('discounttypeid'),
                    }}
                />
              </Grid>
              <Grid item xs={6} className={styles.selectcontrol} style={{marginTop: '10px'}}>
                <SelectInput
                    name="discountitemids"
                    label="Item Discounted"
                    options={getItemListOptions()}
                    textFieldProps={{ fullWidth: true }}
                    includeNone={false}
                    multiple={false}
                    disabled={!displayItemDiscount}
                />
              </Grid>
              <Grid item xs={6} className={styles.selectcontrol} style={{marginTop: '10px'}}>
                <SelectInput
                    name="discountmethodid"
                    label="Promo Code Method"
                    required={true}
                    includeNone={false}
                    textFieldProps={{ fullWidth: true }}
                    options={getDiscountMethodOptions()}
                    rules={{
                      validate: (val) => (val?.length === 0 || val === 'none' || val === 0) ?  "" : clearErrors('discountmethodid'),
                    }}
                />
              </Grid>
              <Grid item xs={6} className={styles.selectcontrol} style={{marginTop: '10px'}}>
                <TextInput
                    name="discountamount"
                    label={displayPaymentMethodAmount ? "Amount" : "Percentage"}
                    endAdornment={displayPaymentMethodAmount ? "" : "%"}
                    startAdornment={displayPaymentMethodAmount ? "$" : ""}
                    required
                    textFieldProps={{ fullWidth: true }}
                />
              </Grid>
              <Grid item xs={6} className={styles.selectcontrol} style={{marginTop: '10px'}}>
                <TextInput
                    name="discountminimumquantityneeded"
                    label="Min Quantity Needed"
                    // required
                    textFieldProps={{ fullWidth: true }}
                />
              </Grid>
              <Grid item xs={6} className={styles.selectcontrol} style={{marginTop: '10px'}}>
                <TextInput
                    name="discountminimumpurchaseneeded"
                    label="Minimum Purchase Amount Needed"
                    startAdornment={"$"}
                    // required
                    textFieldProps={{ fullWidth: true }}
                />
              </Grid>
              <Grid item xs={6} className={styles.selectcontrol} style={{marginTop: '10px'}}>
                <DateTimeInput
                    name="discountdatestart"
                    defaultValue={null}
                    label="Start Date"
                    dateTimeProps={{ fullWidth: true }}
                    textFieldProps={{ fullWidth: true }}
                />
              </Grid>
              <Grid item xs={6} className={styles.selectcontrol} style={{marginTop: '10px'}}>
                <DateTimeInput
                    name="discountdateend"
                    defaultValue={null}
                    label="End Date"
                    dateTimeProps={{ fullWidth: true }}
                    textFieldProps={{ fullWidth: true }}
                />
              </Grid>
              <Grid item xs={6} className={styles.selectcontrol} style={{marginTop: '10px'}}>
                <SelectInput
                    name="discountactive"
                    label="Status"
                    options={[{value: 'active', label: 'Active'}, {value: 'inactive', label: 'Inactive'}]}
                    textFieldProps={{ fullWidth: true, required: true }}
                    required={true}
                    includeNone={false}
                />
              </Grid>
            </Grid>
          </HookForm>
        </DialogContent>
        <DialogActions>
          <Button
              variant="contained"
              color="secondary"
              onClick={() => setIsOpen(false)}>
            Cancel
          </Button>
          <Button
              variant="contained"
              className={styles.submitButton}
              type="submit"
              form="discount-form">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>

  )
}
